module.exports = __webpack_public_path__ + "assets/Theta.95df9d8f231adb66a1ab5aad923d4f67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Theta.png
// module id = 848
// module chunks = 0